import { render, staticRenderFns } from "./hzTwo.vue?vue&type=template&id=01b0ae68&scoped=true"
import script from "./hzTwo.vue?vue&type=script&lang=js"
export * from "./hzTwo.vue?vue&type=script&lang=js"
import style0 from "./hzTwo.vue?vue&type=style&index=0&id=01b0ae68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b0ae68",
  null
  
)

export default component.exports